<template>
  <div class="FilesDownloads">
    <el-button type="primary" @click="openDialog()">新增</el-button>

    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="序号" width="180"></el-table-column>
      <el-table-column prop="title" label="文件名称" width="180"></el-table-column>
      <el-table-column prop="description" label="文件描述">
        <template slot-scope="scope">
          <p v-if="scope.row.description.length > 100">{{scope.row.description.substring(0,100)}} ...</p>
          <p v-else>{{scope.row.description}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="fileType" label="文件类别">
        <template slot-scope="scope">{{scope.row.type == 1 ? '技术手册':'产品手册'}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <el-dialog title="文件编辑" :visible.sync="dialogFormVisible">
      <el-form :model="formData">
        <!-- <el-form-item label="文件名称" :label-width="formLabelWidth">
          <el-input v-model="formData.title" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="文件" :label-width="formLabelWidth">
          <!-- 只能上传一个 -->
          <el-upload
            class="avatar-uploader"
            :action="$imgUrl"
            :headers="headers"
            :on-success="handleSuccess"
            :show-file-list="false"
          >
          <el-button size="small" type="primary">点击上传</el-button>
          <!-- 显示文件 -->
          <span v-if="formData.filePath" class="el-upload-list__item-thumbnail">
            {{formData.title}}
          </span>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件描述" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="10" v-model="formData.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文件类别" :label-width="formLabelWidth">
          <el-radio v-model="formData.fileType" label="1">技术资料</el-radio>
          <el-radio v-model="formData.fileType" label="2">产品手册</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "loginFilesDownloads",
  data() {
    return {
      options: {},
      headers: {},
      tableData: [],
      formData: {
        title: "",
        filePath: "",
        fileType: '1',
        description: "",
        createTime: new Date()
      },
      dialogFormVisible: false,
      formLabelWidth: "120px",
      loading: true
    };
  },
  mounted() {
    let token = "Bearer " + sessionStorage.getItem("token");
    this.headers = {
      Authorization: token
    };
    this.loadData();
  },
  methods: {
    handleSuccess(response, file, fileList) {
      window.console.log(response, file, fileList);
      // 更新title
      this.formData.title = file.name
      this.formData.filePath = response.result
    },
    loadData() {
      this.loading = true;
      const params = {
        type: 1,
        num: 100
      };
      this.$http
        .get("FilesDownloads", {
          params
        })
        .then(response => {
          // window.console.log(response);
          this.tableData = response.result;
          this.loading = false;
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },
    openDialog() {
      // 清除数据
      this.formData.id = 0;
      this.formData.title = "";
      this.formData.filePath = "";
      this.formData.description = "";
      this.formData.createTime = new Date();
      this.dialogFormVisible = true;
    },
    handleCreateOrModify() {
      if (!this.formData.id) {
        this.loading = true;
        this.$http
          .post("FilesDownloads", this.formData)
          .then(response => {
            window.console.log(response);
            this.loading = false;
            this.$message({
              message: "创建成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.loadData();
          })
          .catch(e => {
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
      } else {
        this.loading = true;
        this.$http
          .put("FilesDownloads", this.formData,)
          .then(response => {
            this.loading = false;
            window.console.log(response);
            this.$message({
              message: "修改成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.loadData();
          })
          .catch(e => {
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
      }
    },
    //编辑
    handleEdit(index, row) {
      //index:第几行   row:这一行的数据
      window.console.log(index, row);
      this.formData = row;
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 已确认删除
          // 调接口删除
          this.loading = true;
          this.$http
            .delete(`FilesDownloads/${row.id}`, null, )
            .then(response => {
              this.loading = false;
              window.console.log(response);
              this.$message({
                message: "删除成功！",
                type: "success"
              });
              this.loadData();
            })
            .catch(e => {
              this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-table {
  margin-top: 20px;
}
</style>